import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DropzoneModule } from 'ngx-dropzone-wrapper';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { AiAssistantModule } from 'src/app/shared/ai-assistant/ai-assistant.module';
import { UploadResumesComponent } from './upload-resumes.component';

@NgModule({
  declarations: [UploadResumesComponent],
  imports: [
    CommonModule,
    FormsModule,
    PipesModule,
    AiAssistantModule,
    DropzoneModule
  ],
  exports: [UploadResumesComponent],
  entryComponents: [UploadResumesComponent]
})
export class UploadResumesModule { }
